<template>
    <div class="skeleton-container">
        <template v-if="loading">
            <div
                class="skeleton loading-element"
                :class="[width, { light: light }]"
                :style="`height: ${height}`"
            ></div>
        </template>
        <template v-else-if="data === null">
            <p :class="{ 'grey05--text': !light }">
                --
            </p>
        </template>
        <template v-else>
            <slot></slot>
        </template>
    </div>
</template>

<script setup>
const props = defineProps({
    // data is required, but allowed to be undefined
    // cannot have required prop be undefined - https://github.com/vuejs/core/issues/5471
    data: {
        type: [String, Number, null],
        default: null
    },
    loading: {
        type: Boolean,
        default: false
    },
    width: {
        validator(value) {
            return ['three-quarter', 'half', 'quarter'].includes(value);
        },
    },
    height: {
        type: String,
        default: '20px'
    },
    light: {
        type: Boolean,
        default: false,
    },
});
</script>
<script>
export default {
    name: 'AonSkeleton',
}
</script>
<style lang="scss">
.skeleton-container {
    width: 100%;
    display: flex;
    align-items: end;
}
.skeleton {
    animation: skeleton-loading 1s linear infinite alternate;
}

.skeleton.light {
    animation: skeleton-loading-light 1s linear infinite alternate;
}

@keyframes skeleton-loading {
    0% {
        background-color: $grey02;
    }
    100% {
        background-color: $grey01;
    }
}

@keyframes skeleton-loading-light {
    0% {
        background-color: $grey05;
    }
    100% {
        background-color: $grey06;
    }
}
.loading-element {
    height: 20px;
    background: $grey02;
    border-radius: 5px;
    width: 100%;
    &.quarter {
        width: 25%;
    }
    &.half {
        width: 50%;
    }
    &.three-quarter {
        width: 75%;
    }
}
</style>
